<template>
    <div v-if="lat && long">
        <div id="m"></div>

        <div class="widget-map-bottom pt-3 pb-3">
            <a target="_blank" :href="googleMapsUrl" v-text="Lang.get('messages.showMap')"></a>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['lat', 'long'],

        computed: {
            googleMapsUrl() {
                return `http://maps.google.com/maps?q=${this.lat},${this.long}&ll=${this.lat},${this.long}">`;
            }
        },

        mounted: function () {
            let vm = this;

            var center = SMap.Coords.fromWGS84(vm.long, vm.lat);
            var m = new SMap(JAK.gel("m"), center, 12);
            var sync = new SMap.Control.Sync();

            var layer = new SMap.Layer.Marker();
            m.addLayer(layer);
            layer.enable();

            var options = {};
            var marker = new SMap.Marker(center, "Poloha", options);
            layer.addMarker(marker);

            m.addDefaultLayer(SMap.DEF_BASE).enable();
            m.addControl(sync);
        }
    }
</script>
